module.exports = __webpack_public_path__ + "img/lg_ring_g_i_0_1@3x.8a95f78b.png";